import { Dropdown, Ripple, initMDB } from "mdb-ui-kit";
initMDB({ Dropdown, Ripple });
import { TokenStorageService } from '../tokenStorage.js';
import toastr from 'toastr';
// Allowed values for 'sort' and 'order' to prevent manipulation
const validOrderValues = ['ASC', 'DESC'];
const validSortValues = ['popular', 'latest', 'trending', 'alphabetical', 'position'];

export interface CollectionRating {
    id?: string
    opinion: boolean|null
    collection?: string
    user?: string
}

export interface CollectionReport {
    id?: string
    details?: string
    solved?: boolean
    collection?: string
    user?: string
}

// Function to validate query parameters on page load
function validateQueryParamsOnLoad() {
    const url = new URL(window.location.href);
    const order = url.searchParams.get('order');
    const sort = url.searchParams.get('sort');

    // Check if 'order' and 'sort' have valid values; if not, clear all query parameters
    if ((order && !validOrderValues.includes(order)) || (sort && !validSortValues.includes(sort))) {
        url.search = ''; // Clear all query parameters
        window.location.href = url.toString(); // Reload page without query parameters
    }
}

// Function to update URL parameters and refresh the page
function updateQueryParams(params: Record<string, string>) {
    const url = new URL(window.location.href);

    // Update or add each query parameter
    Object.keys(params).forEach(key => {
        url.searchParams.set(key, params[key]);
    });

    // Redirect to the updated URL
    window.location.href = url.toString();
}

// Event listener for changes in the "order" and "sort" radio groups
function setupRadioListeners() {
    const orderRadios = document.querySelectorAll<HTMLInputElement>('input[name="order"]');
    const sortRadios = document.querySelectorAll<HTMLInputElement>('input[name="sort"]');

    // Listen to changes in "order" radio group
    orderRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            if (radio.checked) {
                updateQueryParams({ order: radio.value });
            }
        });
    });

    // Listen to changes in "sort" radio group
    sortRadios.forEach(radio => {
        radio.addEventListener('change', () => {
            if (radio.checked) {
                updateQueryParams({ sort: radio.value });
            }
        });
    });
}

const tokenStorageService = new TokenStorageService();

$(function($) {
    $('#delete_collection').on('click', function (event) {
        event.preventDefault();
        jconfirm({
            title: 'Confirmation !',
            content: 'Are you sure you want to delete this collection there is no going back if you confirm this action all the data related to this collection will be removed including views, comments, likes and dislikes.',
            type: 'red',
            columnClass: 'large',
            theme: 'dark',
            buttons: {
                delete: {
                    text: "Yes Delete",
                    btnClass: 'btn-success',
                    action: () => {
                        delete_collection(this.getAttribute('data-id'))
                    }
                },
                cancel: {
                    text: "Cancel",
                    btnClass: 'btn-danger float-left',
                }
            }
        });
    });
    function delete_collection(collectionId){
        if(tokenStorageService.isLoggedIn()){
            // Make a POST request to the remote API
            axios.post(`https://api.abyssreader.com/api/collections/delete/${collectionId}`)
            .then(response => {
                if(response.data){
                    toastr.success("The collection has been removed successfully")
                    window.location.assign("/profile/collections")
                } else {
                    toastr.success("An error occurred during the process, please try again later!")
                }
            })
            .catch(error => {
                toastr.error("An error occurred during the process, please try again!");
            })
        } else {
            toastr.error("An error occurred during the process, please try again!");
        }
    }
    $('.like_action').on('click', function (event) {
        const button = $(this);
        addOpinionToCollection(event, button, true);
    });

    $('.dislike_action').on('click', function (event) {
        const button = $(this);
        addOpinionToCollection(event, button, false);
    });

    function addOpinionToCollection(event: JQuery.ClickEvent, button: JQuery<HTMLElement>, status: boolean) {
        event.stopPropagation();
        button.prop('disabled', true);

        const collectionId = button.data('id');
        const currentStatus = button.attr('data-status');

        if (tokenStorageService.isLoggedIn()) {
            const userId = tokenStorageService.getUser().id;
            const opinion = generateOpinion(status, currentStatus, userId, collectionId);

            axios.post(`https://api.abyssreader.com/api/collectionRatings`, opinion)
                .then(response => {
                    const updatedOpinion = response.data.opinion;
                    const likeButton = $(`.like_action[data-id="${collectionId}"]`);
                    const dislikeButton = $(`.dislike_action[data-id="${collectionId}"]`);

                    // Get the current badge values
                    let likeCount = parseInt(likeButton.find('.badge').text()) || 0;
                    let dislikeCount = parseInt(dislikeButton.find('.badge').text()) || 0;

                    if (updatedOpinion === null) {
                        toastr.success("Your opinion has been removed from this collection");
                        // Decrement the relevant count if it was previously active
                        if (currentStatus === "on" && status === true) {
                            likeCount--;
                        } else if (currentStatus === "on" && status === false) {
                            dislikeCount--;
                        }
                        likeButton.attr('data-status', 'off');
                        dislikeButton.attr('data-status', 'off');
                    } else if (updatedOpinion === true) {
                        toastr.success("You liked this collection");
                        // Increment like and decrement dislike if needed
                        if (currentStatus !== "on") {
                            likeCount++;
                            if (dislikeButton.attr('data-status') === 'on') {
                                dislikeCount--;
                            }
                        }
                        likeButton.attr('data-status', 'on');
                        dislikeButton.attr('data-status', 'off');
                    } else {
                        toastr.success("You disliked this collection");
                        // Increment dislike and decrement like if needed
                        if (currentStatus !== "on") {
                            dislikeCount++;
                            if (likeButton.attr('data-status') === 'on') {
                                likeCount--;
                            }
                        }
                        likeButton.attr('data-status', 'off');
                        dislikeButton.attr('data-status', 'on');
                    }

                    // Update badge values
                    likeButton.find('.badge').text(likeCount);
                    dislikeButton.find('.badge').text(dislikeCount);
                })
                .catch(error => {
                    toastr.error("An error occurred during the process. Please try again!");
                })
                .finally(() => {
                    button.prop('disabled', false);
                });
        } else {
            tokenStorageService.showPoPupLogin();
            button.prop('disabled', false);
        }
    }

    function generateOpinion(status: boolean, currentStatus: any, userId: string, collectionId: string): CollectionRating {
        return {
            opinion: currentStatus === "on" ? null : status,
            user: userId,
            collection: collectionId
        };
    }

    $('.import_collection').on('click', function (event) {
        event.stopPropagation()
        const button = $(this);
        button.prop('disabled', true);
        const collectionId = button.data('id');
        if(tokenStorageService.isLoggedIn()){
            axios.post(`https://api.abyssreader.com/api/backup/import/${collectionId}`, {}, { responseType: 'text' })
                .then((response) => {
                    toastr.success("The collection has been imported successfully!");
                    window.location.assign("/profile/library");
                })
                .catch((error) => {
                    toastr.error("An error occurred during the process, please try again!");
                })
                .finally(() => {
                    button.prop('disabled', false);
                });
        } else {
            tokenStorageService.showPoPupLogin()
            button.prop('disabled', false);
        }
    });

    $('.report_collection').on('click', function (event) {
        event.stopPropagation();
        const button = $(this);
        button.prop('disabled', true);
        const collectionId = button.data('id');
        if(tokenStorageService.isLoggedIn()){
            reportPoPup(collectionId, button)
        } else {
            tokenStorageService.showPoPupLogin();
            button.prop('disabled', false);
        }
    });

    function reportPoPup(collectionId: any, button: any){
        jconfirm({
          title: 'Report the collection',
          rtl: false,
          containerFluid: true,
          columnClass: "medium",
          closeIcon: true,
          icon : 'fas fa-info-circle',
          theme: 'dark',
          type: 'blue',
          typeAnimated: true,
          content:
          '<form class="p-1" id="report_post" name="report_post" method="POST" action="">' +
             '<p class="text-danger error_report m-0 mb-2"></p>' +
             '<div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input" name="option_report" id="option-report-1" value="Some of the mangas in the collection does not work" /><label for="option-report-1" class="custom-control-label">Some of the mangas in the collection does not work</label></div>' +
             '<div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input" name="option_report" id="option-report-2" value="There are duplicated mangas in this collection" /><label for="option-report-2" class="custom-control-label">There are duplicated mangas in this collection</label></div>' +
             '<div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input" name="option_report" id="option-report-3" value="This collection does not make any sense and there is no synergy" /><label for="option-report-3" class="custom-control-label">This collection does not make any sense and there is no synergy</label></div>' +
             '<div class="custom-control custom-checkbox"><input type="checkbox" class="custom-control-input" name="option_report" id="option-report-4" value="Other problems" /><label for="option-report-4" class="custom-control-label">Other problems</label></div>' +
             '<div class="report">' +
                  '<textarea type="text" maxlength="500" id="detail_report" class="md-textarea-auto form-control" placeholder="Explain your problem more precisely or if your problem is not within the options above"></textarea>' +
             '</div>' +
          '</form>',
          buttons: {
              submit: {
                  text: 'Send',
                  //icon : 'fas fa-check',
                  btnClass: 'btn-red submit-report',
                  action: function() {
                     let jc : any = this
                     // get form
                     const form = jc.$content.find('form')[0]
                     // get detail report
                     const detail_report = form.elements.detail_report.value
                     // get error block
                     let error = jc.$content.find(".error_report")[0]
                     // get checked problems
                     let options_report = []
                     for (let option of form.elements.option_report) {
                        if (option.checked)
                           options_report.push(option.value)
                     }
                     // check options checked
                     if (options_report.length == 0){
                        error.textContent = "You must choose at least one problem"
                     } else {
                        error.textContent = ""
                        sendReportCollection(detail_report, options_report, jc, collectionId, button)
                        jc.showLoading(true)
                     }
                     return false
                  }
              },
              cancel: {
                  text: 'Cancel',
                  btnClass: 'btn-blue cancel-report'
              },
          },
        });
    }

    function sendReportCollection(detail_report : string, options_report : string[], jc : any, collectionId: any, button : any){
        let report : CollectionReport = {
          details : options_report.join(", ") + ".\n" + detail_report,
          solved : false,
          user : tokenStorageService.getUser().id,
          collection : collectionId
        }
        axios.post(`https://api.abyssreader.com/api/collectionReports`, report)
            .then(response => {
                if(response.data){
                    jc.setType("green")
                    jc.setIcon("fas fa-check-circle")
                    jc.setTitle("Operation accomplished successfully !")
                    jc.setContent("We have received your report and will look into it as soon as possible.")
                } else {
                    jc.setType("red")
                    jc.setIcon("fas fa-exclamation-triangle")
                    jc.setTitle("Something went wrong !")
                    jc.setContent("You have already submitted your report on this collection. Please wait until we resolve the issue.")
                }
            })
            .catch(error => {
                jc.setType("red")
                jc.setIcon("fas fa-exclamation-triangle")
                jc.setTitle("Something went wrong !")
                jc.setContent("An error occurred while trying to submit your report, please try again.")
            })
            .finally(() => {
                jc.buttons.submit.hide()
                jc.hideLoading(true)
                button.prop('disabled', false);
            });
    }
});

// Initialize all listeners on page load
document.addEventListener('DOMContentLoaded', () => {
    validateQueryParamsOnLoad(); // Validate 'order' and 'sort' query parameters on page load
    setupRadioListeners();
});
